/*
 |--------------------------------------------------------------------------
 | Midone Built-in Components
 |--------------------------------------------------------------------------
 |
 | Import Midone built-in components.
 |
 */
import "./bootstrap";
import "@left4code/tw-starter/dist/js/svg-loader";
import "@left4code/tw-starter/dist/js/accordion";
import "@left4code/tw-starter/dist/js/alert";
import "@left4code/tw-starter/dist/js/dropdown";
import "@left4code/tw-starter/dist/js/modal";
import "@left4code/tw-starter/dist/js/tab";

/*
 |--------------------------------------------------------------------------
 | 3rd Party Libraries
 |--------------------------------------------------------------------------
 |
 | Import 3rd party library JS files.
 |
 */
import "./lucide";
//import "./tiny-slider";
import "./tippy";
import "./datepicker";
import "./tom-select";
//import "./dropzone";
import "./validation";
import "./zoom";
import "./notification";
/*
 |--------------------------------------------------------------------------
 | Custom Components
 |--------------------------------------------------------------------------
 |
 | Import JS custom components.
 |
 */
//import "./chat";
import "./show-modal";
import "./show-slide-over";
import "./show-dropdown";
//import "./search";
import "./side-menu";
import "./mobile-menu";
import "./side-menu-tooltip";

import "./btddispo/roster";
import "./btddispo/dispo";
import "./btddispo/availability";
import "./btddispo/dayinfo";
import "./btddispo/tooltip";
import "./btddispo/employees";
import "./btddispo/dark-mode-switcher";
import "./btddispo/vacation_list";
import "./btddispo/vacation_request";
import "./btddispo/inventory";
import "./btddispo/inv_min_stock";
import "./btddispo/native-pickers";
//import "./tabulator";

/*
 |--------------------------------------------------------------------------
 | Lazy-loaded heavy libraries
 |--------------------------------------------------------------------------
 |
 | CKEditor, Chart.js and FullCalendar are large (~1.4 MiB combined,
 | minified) and only needed on the specific pages that use them. Only
 | import() them when the relevant DOM element is actually present, so
 | pages without a chart/calendar/editor don't pay for them.
 |
 */
if (document.querySelector('.editor')) {
    import(/* webpackChunkName: "ckeditor" */ "./ckeditor-classic");
}
if (document.querySelector('[id^="chart-"]')) {
    import(/* webpackChunkName: "chartjs" */ "./chart");
}
if (document.querySelector('#calendar, #vrv')) {
    import(/* webpackChunkName: "fullcalendar-roster" */ "./calendar");
}
if (document.querySelector('[data-tour-id]')) {
    import(/* webpackChunkName: "tour" */ "./tour");
}
if (document.querySelector('[data-sortable-url]')) {
    import(/* webpackChunkName: "sortable" */ "./btddispo/sortable-lists");
}

if (document.querySelector('.chart-event-tickets')) {
    import(/* webpackChunkName: "chartjs" */ "./btddispo/dispo-charts");
}
if (document.querySelector('#planner, #day-planner')) {
    import(/* webpackChunkName: "fullcalendar-planner" */ "./btddispo/planner");
}
if (document.querySelector('#chart-item-location')) {
    import(/* webpackChunkName: "chartjs" */ "./btddispo/inventory_charts");
}